let activeTab = null
let showAll = false
const tabsLengths = {}
const debounceTime = 300

let filterForm = null
let queryItemsList = null
let withTabs = null
document.addEventListener('DOMContentLoaded', function (e) {
  withTabs = document.getElementById('with-tabs').value === 'true'
  const autoCompleteInput = document.querySelector('#query-input')
  queryItemsList = document.querySelector('#query-items-list')
  const showAllButtons = document.querySelectorAll('button#show-all-button')

  const loader = document.querySelector('#query-loader')
  const itemsCount = parseInt(document.getElementById('count').value)
  let timeoutId

  const serviceUrl = document.getElementById('service-url').value
  const contentId = document.getElementById('content-id').value

  const queryForm = document.querySelector('#query-form')
  filterForm = document.querySelector('#filter-form')

  let selectedFilters = {}
  let searchSring = ''

  if (filterForm) {
    const showFiltersButton = document.getElementById('show-filters')
    const activeFilters = document.getElementById('active-filters')

    const removeFiltersButton = document.getElementById('remove-filters')

    removeFiltersButton.addEventListener('click', event => {
      e.preventDefault()
      selectedFilters = {}

      activeFilters.innerHTML = ''
      const checkBoxes = filterForm.querySelectorAll('input[type=checkbox]')
      for (let i = 0; i < checkBoxes.length; i++) {
        checkBoxes[i].checked = false
      }

      performFetchQuery()
    })

    activeFilters.addEventListener('click', event => {
      const currentFilter = event.target

      const filterId = currentFilter.dataset.filterId || ''
      const checkBox = document.getElementById(filterId)
      checkBox.checked = false
      const checkBoxParent = checkBox.parentNode.parentNode
      const field = checkBoxParent.dataset.field || ''
      const value = checkBox.value || ''
      if (field && value) {
        const valueIndex = selectedFilters[field].indexOf(value)
        selectedFilters[field].splice(valueIndex, 1)
        currentFilter.remove()
      }

      performFetchQuery()
    })

    showFiltersButton.addEventListener('click', event => {
      toggleFilterSection()
    })

    filterForm.addEventListener('submit', event => {
      event.preventDefault()

      toggleFilterSection()
      performFetchQuery()
    })

    filterForm.addEventListener('change', event => {
      const checkBox = event.target
      const parent = checkBox.parentNode.parentNode

      const checked = checkBox.checked

      const field = parent.dataset.field || ''
      const value = checkBox.value || ''

      if (field && value && checked) {
        if (!selectedFilters[field]) {
          selectedFilters[field] = []
        }
        selectedFilters[field].push(value)

        const activeFieldButton = document.createElement('button')
        activeFieldButton.textContent = checkBox.value
        activeFieldButton.id = 'active-field-' + checkBox.id
        activeFieldButton.dataset.filterId = checkBox.id
        activeFilters.appendChild(activeFieldButton)
      } else if (field && value) {
        const valueIndex = selectedFilters[field].indexOf(value)
        const activeFieldButton = document.getElementById('active-field-' + checkBox.id)
        activeFieldButton.remove()
        selectedFilters[field].splice(valueIndex, 1)
      }

      performFetchQuery()
    })
  }

  queryForm && queryForm.addEventListener('submit', event => {
    event.preventDefault()

    performFetchQuery()
  })

  autoCompleteInput && autoCompleteInput.addEventListener('input', input => {
    searchSring = input.target.value

    performFetchQuery()
  })

  showAllButtons.forEach(showAllButton => {
    showAllButton.addEventListener('click', () => {
      showAll = true
      const listItems = document.querySelectorAll('li.search-nav-list__item')

      listItems.forEach(listItem => {
        listItem.classList.remove('hidden')
      })

      showAllButton.classList.add('hidden')
    })
  })

  function toggleFilterSection () {
    const filtersSection = document.getElementById('filters')
    if (filtersSection.style.display !== 'none') {
      event.target.text = 'Filter'
      filtersSection.style.display = 'none'
      event.target.classList.remove('filtersOpen')
    } else {
      event.target.text = 'Lukk'
      filtersSection.style.display = 'flex'
      event.target.classList.add('filtersOpen')
    }
  }

  function performFetchQuery () {
    loader.style.display = 'block'
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => {
      const url = new URL(serviceUrl, window.location.origin)
      url.searchParams.append('q', searchSring)
      url.searchParams.append('contentId', contentId)
      Object.keys(selectedFilters).length && url.searchParams.append('filters', JSON.stringify(selectedFilters))

      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (!withTabs) {
            fillList(queryItemsList, data)
          } else {
            fillTabs(data)
          }
          filterForm && setFilterCount()
          loader.style.display = 'none'
        })
    }, debounceTime)
  }

  function fillList (htmlElement, data) {
    htmlElement.innerHTML = ''
    data.forEach((suggestion, index) => {
      const li = createListItem(suggestion, (index + 1 > itemsCount))
      htmlElement.append(li)
    })

    setButtonVisibility()
  }

  function createListItem (item, isHidden = false) {
    const li = document.createElement('li')
    li.classList.add('search-nav-list__item')
    if (isHidden && !showAll) {
      li.classList.add('hidden')
    }

    const a = document.createElement('a')
    a.classList.add('search-nav-list__link')
    a.setAttribute('href', item.href)
    li.append(a)

    const wrapperDiv = document.createElement('div')
    wrapperDiv.classList.add('search-nav-list__item-wrapper')
    a.append(wrapperDiv)

    const secondWrapperDiv = document.createElement('div')
    secondWrapperDiv.classList.add('l-mt-1')
    wrapperDiv.append(secondWrapperDiv)

    const titleDiv = document.createElement('div')
    titleDiv.classList.add('search-nav-list__item-title')
    titleDiv.textContent = item.title

    if (item.month) {
      const dateDiv = document.createElement('div')
      dateDiv.classList.add('date-circle')
      dateDiv.classList.add('u-bg-color--' + item.color + '-light')
      dateDiv.textContent = item.month
      if (item.day) {
        const dateSpan = document.createElement('span')
        dateSpan.classList.add('big')
        dateSpan.textContent = item.day
        dateDiv.prepend(dateSpan)
      }
      titleDiv.prepend(dateDiv)
    }
    secondWrapperDiv.append(titleDiv)

    const introDiv = document.createElement('div')
    introDiv.classList.add('search-nav-list__item-intro')
    introDiv.textContent = item.intro
    secondWrapperDiv.append(introDiv)

    return li
  }

  function fillTabs (data) {
    const tabsIds = Object.keys(data)
    tabsIds.forEach((tabId) => {
      const divTab = document.getElementById(`content-${tabId}`)
      const tabList = divTab.getElementsByTagName('ul')[0]
      fillList(tabList, data[tabId])

      const tabCount = data[tabId].length
      const tabElement = document.getElementById(tabId)
        .getElementsByClassName('tab-count')[0]
      tabElement.textContent = tabCount
      tabsLengths[tabId] = tabCount
    })

    // Change tab if there is one without items
    if (!tabsLengths[activeTab]) {
      for (const tabId of tabsIds) {
        if (tabsLengths[tabId]) {
          showTab(tabId)
          break
        }
      }
    }
  }

  function init () {
    if (withTabs) {
      const firstTab = document.querySelectorAll('.tab-btn')[0]
      const firstContent = document.querySelectorAll('.tab-content')[0]
      firstTab.classList.add('active-tab')
      firstContent.classList.add('active-content')

      activeTab = firstTab.id
      initTabsLengths()
    }
    filterForm && setFilterCount()

    setButtonVisibility()
  }

  function initTabsLengths () {
    const tabsSection = document.getElementById('tabs')
    const tabs = tabsSection.querySelectorAll('.tab-content')

    for (let i = 0; i < tabs.length; i++) {
      const tabId = tabs[i].id.split('content-')[1] || ''
      const items = tabs[i].querySelectorAll('.search-nav-list__item')
      tabsLengths[tabId] = items.length
    }
  }

  function setButtonVisibility () {
    document.querySelectorAll('#query-items-list').forEach((list, index) => {
      if (list.getElementsByTagName('li').length <= itemsCount) {
        showAllButtons[index].classList.add('hidden')
      } else if (!showAll) {
        showAllButtons[index].classList.remove('hidden')
      }
    })
  }

  init()
})

function showTab (tabId) {
  const tabButtons = document.querySelectorAll('.tab-btn')
  activeTab = tabId
  tabButtons.forEach(function (button) {
    if (button.id === tabId) {
      button.classList.add('active-tab')
    } else {
      button.classList.remove('active-tab')
    }
  })

  const tabContents = document.querySelectorAll('.tab-content')
  tabContents.forEach(function (content) {
    if (content.id === 'content-' + tabId) {
      content.classList.add('active-content')
    } else {
      content.classList.remove('active-content')
    }
  })

  const filterForm = document.querySelector('#filter-form')
  filterForm && setFilterCount()
}

function setFilterCount () {
  const filterCount = document.getElementById('filter-count')
  const count = withTabs ? tabsLengths[activeTab] : (queryItemsList && queryItemsList.children && queryItemsList.children.length) || 0
  filterCount.textContent = `Viser ${count} treff`
}
